// extracted by mini-css-extract-plugin
export default {"overlay":"wzPzVZ","active":"Q9CzAY","preloader":"KaPpe8","loading":"Xe3rh6","dot":"KoQ2ig","full-circle":"OOs3cm","fullCircle":"OOs3cm","circle":"eScGDP"};